import React from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import { deletePools, listOctaviaHealthMonitors, listOctaviaPoolMembers } from './actions'
import Modal from 'core/elements/modal'
import { useAppSelector } from 'app/store'
import useListAction from 'core/hooks/useListAction'
import { octaviaHealthMonitorsSelector, octaviaPoolMembersSelector } from './selectors'
import { makeStyles } from '@material-ui/styles'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import Theme from 'core/themes/model'
import clsx from 'clsx'
import DeleteDialog from 'core/components/DeleteDialog'

export default function DeletePoolsDialog({ rows, onClose }) {
  const classes = useStyles()
  const poolIds = rows?.map((pool) => pool?.id)
  useListAction(listOctaviaPoolMembers, { params: { poolIds } })
  useListAction(listOctaviaHealthMonitors)

  const memberDetails = useAppSelector(octaviaPoolMembersSelector)
  const monitorDetails = useAppSelector(octaviaHealthMonitorsSelector)

  // collect associated pools
  const associatedPools = rows?.filter(
    (row) =>
      memberDetails?.some((member) => member?.poolId === row?.id) ||
      monitorDetails?.some((monitor) => monitor?.poolId === row?.id),
  )

  const isPoolAssociated = associatedPools?.length > 0
  const associatedPoolNames = associatedPools?.map((row) => row?.name).join(', ')

  if (isPoolAssociated) {
    return (
      <Modal
        panel="dialog"
        open
        onClose={onClose}
        title={
          <div className={classes.root}>
            <FontAwesomeIcon solid className={clsx(classes.circleIcon, classes.circleError)}>
              circle-xmark
            </FontAwesomeIcon>
            <div className={classes.header}>Delete Pool</div>
          </div>
        }
        footer={
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        }
      >
        <Text variant="body2">
          You cannot delete the following Pool(s) because they have active Members or an associated
          Health Monitor. Please remove all Members or detach the Health Monitor before deleting the
          Pool.
          <br />
          <strong>{associatedPoolNames}</strong>
        </Text>
      </Modal>
    )
  }

  return (
    <DeleteDialog
      rows={rows}
      onClose={onClose}
      deleteAction={deletePools}
      title="Delete Pool(s)"
      resourceLabel="Pools"
    />
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    paddingLeft: theme.spacing(1),
  },
  root: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  circleIcon: {
    fontSize: '18px',
    color: '#fff',
  },
  circleError: {
    background: theme.palette.graphRed[100],
    color: theme.palette.graphRed[500],
  },
}))
